export const SHIPPINGS = 'shippings'

export const SHIPPING_STATUS = ['queued', 'sent']
